module.exports = __webpack_public_path__ + "img/ic-cubo.72ca9a6d.svg";